import {
  MockMap,
} from '@ama-sdk/core';
import {
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineJourneys,
  createBaggage,
  createMockData,
  createMockDataWithResponse,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  acceptedJourneyAfterDeletePax,
  acceptedJourneyAfterDeletePax3,
  allAcceptedJourneyFor2Pax,
  authorization,
  journeyWith2Pax,
  notAcceptedJourneyAfterDeletePax,
  partialAcceptedjourneyFor2Pax,
  twoAdtJourneyTravelers,
} from '../../mock';
import {
  addedBaggageTemplate,
  baggageToPayfortwopax,
  chargeableSeatsToPayForTwoPax,
  defaultCheckInBaggagePolicies,
  defaultCheckInBaggagePoliciesFor2Adt,
  firstCHSeatOnJourney,
  journeyTwoPax,
  noItemToPayError,
  paymentRecords,
  seatmap,
  secondCHSeatOnJourney,
} from '../../mock/data';

const journeyElementIds = journeyTwoPax.journeyElements.map((je: JourneyElementCommon) => je.id);

export const ow1Journey2AdtPartialCheckinPartialPayment: MockMap = {
  addJourneyBags: [createMockData([
    createBaggage({
      template: addedBaggageTemplate,
      id: 0
    }),
    createBaggage({
      template: addedBaggageTemplate,
      id: 1
    })])],
  authorizeJourneyPaymentRecord: [createMockData(authorization)],
  confirmJourneyPaymentRecord: [createMockData(paymentRecords)],
  createJourneyPaymentRecord: [createMockData(paymentRecords)],
  generateBoardingPasses: [createMockData(combineBoardingPassResults(undefined, {
    journeyElementIds
  }).items)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies([defaultCheckInBaggagePolicies, defaultCheckInBaggagePoliciesFor2Adt]).items)],
  getJourneyUnpaidItems: [
    createMockData(chargeableSeatsToPayForTwoPax),
    createMockData(baggageToPayfortwopax),
    createMockData(baggageToPayfortwopax),
    createMockData(noItemToPayError)
  ],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201),
    createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201),
    createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201),
    createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  assignSeatToJourneyElement: [
    createMockData(firstCHSeatOnJourney[0]),
    createMockData({
      ...firstCHSeatOnJourney[0],
      ...secondCHSeatOnJourney[0],
      journeyElementId: twoAdtJourneyTravelers[1].id
    })
  ],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockData(combineJourneys([journeyWith2Pax]).items),
    createMockData(combineJourneys([partialAcceptedjourneyFor2Pax]).items),
    createMockData(combineJourneys([allAcceptedJourneyFor2Pax]).items)],
  retrieveJourney: [
    createMockData(notAcceptedJourneyAfterDeletePax),
    createMockData(acceptedJourneyAfterDeletePax),
    createMockData(acceptedJourneyAfterDeletePax3)
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)],
  removeTravelersFromJourney: [createMockData({})],
  updateJourneySeats: [
    createMockData({
      ...firstCHSeatOnJourney[0],
      journeyElementIds
    }),
    createMockData({
      ...firstCHSeatOnJourney[1],
      journeyElementIds
    })
  ]
};
